(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    function init() {
      var content = document.querySelector('[data-article-content]');
      if (!content || content.dataset.articleReady === 'true') return;
      content.dataset.articleReady = 'true';

      content.querySelectorAll('table').forEach(function (table) {
        if (table.parentElement && table.parentElement.classList.contains('article-page__table-scroll')) return;
        var scroller = document.createElement('div');
        scroller.className = 'article-page__table-scroll';
        table.replaceWith(scroller);
        scroller.appendChild(table);
      });

      var progress = document.querySelector('[data-article-progress]');
      if (progress) {
        var update = function () {
          var rect = content.getBoundingClientRect();
          var scrollable = rect.height - window.innerHeight;
          var ratio = scrollable > 0 ? Math.min(Math.max(-rect.top / scrollable, 0), 1) : 0;
          progress.style.width = ratio * 100 + '%';
        };
        document.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const pageSelector = 'ca-cart-page';
    const drawerSectionId = 'cart-drawer';

    class CaCartPage extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.addEventListener('click', (event) => this.handleClick(event), { signal });
        this.addEventListener('change', (event) => this.handleChange(event), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }

      get content() {
        return this.querySelector('[data-cart-page-content]');
      }

      setBusy(isBusy) {
        this.toggleAttribute('aria-busy', isBusy);
        this.querySelectorAll('[data-cart-control], [name="checkout"]').forEach((control) => {
          control.disabled = isBusy;
        });
      }

      setError(message = '') {
        const error = this.querySelector('[data-cart-error]');
        if (!error) return;
        error.textContent = message;
        error.hidden = !message;
      }

      announce(message) {
        const status = this.querySelector('[data-cart-status]');
        if (!status) return;
        status.textContent = '';
        requestAnimationFrame(() => {
          status.textContent = message;
        });
      }

      renderSection(sectionHtml) {
        if (!sectionHtml || !this.content) throw new Error(this.dataset.genericError);
        const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const nextContent = parsed.querySelector(`${pageSelector} [data-cart-page-content]`);
        if (!nextContent) throw new Error(this.dataset.genericError);
        this.content.replaceWith(nextContent);
        return true;
      }

      renderResult(result) {
        this.renderSection(result.sections?.[this.dataset.sectionId]);
        const drawer = document.querySelector('ca-cart-drawer');
        if (drawer) drawer.renderSection(result.sections?.[drawerSectionId]);
      }

      async applyResult(result, cartApi) {
        try {
          this.renderResult(result);
          return result;
        } catch (error) {
          const recovered = await cartApi.reload({
            sectionIds: [this.dataset.sectionId, drawerSectionId],
            genericError: this.dataset.genericError,
          });
          this.renderResult(recovered);
          return recovered;
        }
      }

      getActiveControl() {
        const active = document.activeElement;
        if (!(active instanceof HTMLElement) || !this.contains(active)) return null;
        if (active.matches('[data-cart-page-quantity-input]')) {
          return { type: 'quantity', line: active.dataset.line };
        }
        if (active.matches('[data-cart-page-quantity-change]')) {
          return {
            type: 'change',
            line: active.dataset.line,
            delta: active.dataset.delta,
          };
        }
        if (active.matches('[data-cart-page-remove]')) {
          return { type: 'remove', line: active.dataset.line };
        }
        return null;
      }

      restoreControlFocus(control) {
        if (!control) return;
        const line = Math.max(1, Number(control.line));
        let selector;
        if (control.type === 'quantity') {
          selector = `[data-cart-page-quantity-input][data-line="${line}"]`;
        } else if (control.type === 'change') {
          selector = `[data-cart-page-quantity-change][data-line="${line}"][data-delta="${control.delta}"]`;
        } else if (control.type === 'remove') {
          selector = `[data-cart-page-quantity-input][data-line="${line}"]`;
        }
        const target = selector ? this.querySelector(selector) : null;
        const quantities = this.querySelectorAll('[data-cart-page-quantity-input]');
        const previousQuantity = quantities.item(quantities.length - 1);
        (target || previousQuantity || this.querySelector('[data-cart-page-heading]'))?.focus();
      }

      restoreQuantity(line, quantity) {
        const input = this.querySelector(`[data-cart-page-quantity-input][data-line="${line}"]`);
        if (input && Number.isFinite(quantity)) input.value = String(quantity);
      }

      async change(line, quantity, previousQuantity) {
        const activeControl = this.getActiveControl();
        const removed = quantity === 0;
        this.setBusy(true);
        this.setError();

        try {
          const cartApi = window.ConformationalAesthetics?.cart;
          if (!cartApi) throw new Error(this.dataset.genericError);
          let result = await cartApi.changeLine({
            line,
            quantity,
            sectionIds: [this.dataset.sectionId, drawerSectionId],
            genericError: this.dataset.genericError,
          });
          result = await this.applyResult(result, cartApi);
          cartApi.updateHeaderCount(result.cart.item_count);
          this.restoreControlFocus(activeControl);
          this.announce(removed ? this.dataset.removedMessage : this.dataset.updatedMessage);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: result.cart } }));
          return result;
        } catch (error) {
          if (!error.uncertain) this.restoreQuantity(line, previousQuantity);
          this.setError(error.message || this.dataset.genericError);
          this.restoreControlFocus(activeControl);
          throw error;
        } finally {
          this.setBusy(false);
        }
      }

      handleClick(event) {
        const quantityButton = event.target.closest('[data-cart-page-quantity-change]');
        if (quantityButton) {
          const line = Number(quantityButton.dataset.line);
          const input = this.querySelector(`[data-cart-page-quantity-input][data-line="${line}"]`);
          const previousQuantity = Number(input?.value || 0);
          const quantity = Math.max(0, previousQuantity + Number(quantityButton.dataset.delta));
          if (input) input.value = String(quantity);
          this.change(line, quantity, previousQuantity).catch(() => {});
          return;
        }

        const remove = event.target.closest('[data-cart-page-remove]');
        if (remove) {
          event.preventDefault();
          const line = Number(remove.dataset.line);
          const input = this.querySelector(`[data-cart-page-quantity-input][data-line="${line}"]`);
          this.change(line, 0, Number(input?.value || 0)).catch(() => {});
        }
      }

      handleChange(event) {
        const input = event.target.closest('[data-cart-page-quantity-input]');
        if (!input) return;
        const rawQuantity = input.value.trim();
        const quantity = Number(rawQuantity);
        if (rawQuantity === '' || !Number.isInteger(quantity) || quantity < 0) {
          input.value = input.defaultValue;
          this.setError(this.dataset.invalidQuantity);
          input.focus();
          return;
        }
        this.change(Number(input.dataset.line), quantity, Number(input.defaultValue)).catch(() => {});
      }
    }

    if (!customElements.get(pageSelector)) {
      customElements.define(pageSelector, CaCartPage);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form-media"] && !Shopify.designMode) return;
  try {
    
  const initializeContactMedia = (root) => {
    root.querySelectorAll('[data-contact-media]').forEach((section) => {
      if (section.dataset.contactInitialized === 'true') return
      section.dataset.contactInitialized = 'true'

      const form = section.querySelector('form')
      if (!form) return

      const response = form.querySelector('[data-contact-response]')
      if (response) response.focus()

      const clientSummary = form.querySelector('[data-contact-client-errors]')
      const clientErrorList = form.querySelector('[data-contact-client-error-list]')
      let invalidTimer

      const showClientErrors = (focusSummary = true) => {
        const invalidFields = [...form.querySelectorAll('input:invalid, textarea:invalid')]
        clientErrorList.replaceChildren()

        invalidFields.forEach((field) => {
          field.setAttribute('aria-invalid', 'true')
          const label = form.querySelector(`label[for="${CSS.escape(field.id)}"]`)
          const item = document.createElement('li')
          const link = document.createElement('a')
          link.href = `#${field.id}`
          link.textContent = `${label?.textContent.trim() || field.name}: ${field.validationMessage}`
          item.append(link)
          clientErrorList.append(item)
        })

        clientSummary.hidden = invalidFields.length === 0
        if (focusSummary && invalidFields.length > 0) clientSummary.focus()
      }

      form.addEventListener('invalid', () => {
        window.clearTimeout(invalidTimer)
        invalidTimer = window.setTimeout(showClientErrors, 0)
      }, true)

      form.addEventListener('input', (event) => {
        const field = event.target
        if (!(field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement)) return
        if (field.maxLength > -1 && field.value.length > field.maxLength) {
          field.value = field.value.slice(0, field.maxLength)
        }
        if (field.validity.valid) field.removeAttribute('aria-invalid')
        if (!clientSummary.hidden) showClientErrors(false)
      })

      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault()
          showClientErrors()
          return
        }
        const submit = form.querySelector('[data-contact-submit]')
        const label = form.querySelector('[data-contact-submit-label]')
        const pending = form.querySelector('[data-contact-submit-pending]')
        const pendingStatus = form.querySelector('[data-contact-pending-status]')
        submit.disabled = true
        submit.setAttribute('aria-disabled', 'true')
        label.hidden = true
        pending.hidden = false
        pendingStatus.textContent = pending.textContent
      })
    })
  }

  initializeContactMedia(document)
  document.addEventListener('shopify:section:load', (event) => initializeContactMedia(event.target))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-quick-answers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ca-contact-quick-answers')) {
    customElements.define(
      'ca-contact-quick-answers',
      class CaContactQuickAnswers extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return
          this.abortController = new AbortController()
          const { signal } = this.abortController
          this.addEventListener('click', (event) => this.handleClick(event), { signal })
          this.querySelectorAll('[data-quick-answer-dialog]').forEach((dialog) => {
            dialog.addEventListener('cancel', (event) => {
              event.preventDefault()
              dialog.close()
            }, { signal })
            dialog.addEventListener('close', () => this.handleClose(dialog), { signal })
          })
        }

        disconnectedCallback() {
          this.abortController?.abort()
          this.abortController = null
        }

        open(trigger) {
          const dialog = document.getElementById(trigger.dataset.quickAnswerOpen)
          if (!dialog || !this.contains(dialog) || dialog.open) return
          this.returnFocusTo = trigger
          dialog.showModal()
          dialog.querySelector('[data-quick-answer-close]')?.focus()
        }

        handleClose(dialog) {
          const heading = dialog.querySelector('[data-quick-answer-heading]')
          const content = dialog.querySelector('[data-quick-answer-content]')
          const feedback = dialog.querySelector('[data-quick-answer-feedback]')
          const thanks = dialog.querySelector('[data-quick-answer-thanks]')
          if (heading?.dataset.originalText) heading.textContent = heading.dataset.originalText
          dialog.removeAttribute('data-thanks-visible')
          if (content) content.hidden = false
          if (feedback) feedback.hidden = false
          if (thanks) thanks.hidden = true
          if (this.returnFocusTo?.isConnected) this.returnFocusTo.focus()
          this.returnFocusTo = null
        }

        showThanks(button) {
          const dialog = button.closest('[data-quick-answer-dialog]')
          const heading = dialog?.querySelector('[data-quick-answer-heading]')
          const content = dialog?.querySelector('[data-quick-answer-content]')
          const feedback = dialog?.querySelector('[data-quick-answer-feedback]')
          const thanks = dialog?.querySelector('[data-quick-answer-thanks]')
          if (!heading || !content || !feedback || !thanks) return
          heading.dataset.originalText ||= heading.textContent
          heading.textContent = thanks.dataset.heading
          dialog.setAttribute('data-thanks-visible', '')
          content.hidden = true
          feedback.hidden = true
          thanks.hidden = false
          thanks.focus()
        }

        requestMoreHelp(button) {
          const dialog = button.closest('[data-quick-answer-dialog]')
          const destination = this.dataset.moreHelpDestination
          let contactForm
          try {
            const url = new URL(destination, window.location.href)
            if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.hash) {
              contactForm = document.querySelector(url.hash)
            }
          } catch {}

          if (!contactForm) {
            window.location.assign(destination)
            return
          }

          const subject = contactForm.querySelector('[name="contact[subject]"]')
          const firstInput = contactForm.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])')
          if (subject && !subject.value.trim()) subject.value = button.dataset.question || ''
          this.returnFocusTo = null
          dialog?.close()
          const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
          contactForm.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' })
          firstInput?.focus({ preventScroll: true })
        }

        handleClick(event) {
          const trigger = event.target.closest('[data-quick-answer-open]')
          if (trigger) {
            this.open(trigger)
            return
          }

          const helpful = event.target.closest('[data-quick-answer-helpful]')
          if (helpful) {
            this.showThanks(helpful)
            return
          }

          const moreHelp = event.target.closest('[data-quick-answer-more-help]')
          if (moreHelp) {
            this.requestMoreHelp(moreHelp)
            return
          }

          const dialog = event.target.closest('[data-quick-answer-dialog]')
          if (event.target.closest('[data-quick-answer-close]') || event.target === dialog) {
            dialog?.close()
          }
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('logo-list')) {
    customElements.define(
      'logo-list',
      class LogoList extends HTMLElement {
        connectedCallback() {
          this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.handleMotionChange = () => this.setup();
          this.motionPreference.addEventListener('change', this.handleMotionChange);
          this.setup();
        }

        disconnectedCallback() {
          this.motionPreference?.removeEventListener('change', this.handleMotionChange);
          this.resizeObserver?.disconnect();
        }

        setup() {
          const track = this.querySelector('[data-logo-list-track]');
          const group = this.querySelector('[data-logo-list-group]');
          const viewport = this.querySelector('.logo-list__viewport');
          this.querySelector('[data-logo-list-clone]')?.remove();
          this.resizeObserver?.disconnect();

          if (!track || !group || !viewport || this.dataset.presentation !== 'marquee' || this.motionPreference.matches) return;

          const clone = group.cloneNode(true);
          clone.dataset.logoListClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
            element.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('a').forEach((link) => {
            link.tabIndex = -1;
          });
          track.append(clone);

          const pixelsPerSecond = { slow: 30, medium: 45, fast: 60 }[this.dataset.speed] || 45;
          const setDuration = () => {
            track.style.setProperty('--logo-list-group-min-width', `${viewport.clientWidth}px`);
            track.style.setProperty('--logo-list-duration', `${group.scrollWidth / pixelsPerSecond}s`);
          };

          this.resizeObserver = new ResizeObserver(setDuration);
          this.resizeObserver.observe(group);
          this.resizeObserver.observe(viewport);
          setDuration();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"] && !Shopify.designMode) return;
  try {
    
  class CaProductSpotlight extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      const carousel = this.querySelector('ca-carousel');
      if (!carousel) return;

      this.abortController = new AbortController();
      this.mediaObserver = new MutationObserver(() => this.syncMedia(this.selectedIndex));
      this.mediaObserver.observe(this, { childList: true, subtree: true });
      carousel.addEventListener(
        'ca-carousel:select',
        (event) => this.syncMedia(event.detail.index),
        { signal: this.abortController.signal }
      );
      this.syncMedia(0);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.mediaObserver?.disconnect();
      this.abortController = null;
      this.mediaObserver = null;
    }

    syncMedia(selectedIndex) {
      this.selectedIndex = selectedIndex;
      this.querySelectorAll('[data-product-spotlight-media]').forEach((item, index) => {
        const isSelected = index === selectedIndex;
        item.classList.toggle('is-selected', isSelected);
        if (isSelected) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
      });
    }
  }

  if (!customElements.get('ca-product-spotlight')) {
    customElements.define('ca-product-spotlight', CaProductSpotlight);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protocol-quiz"] && !Shopify.designMode) return;
  try {
    
  const ELEMENT_NAME = "ca-protocol-quiz";

  class CaProtocolQuiz extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.steps = Array.from(this.querySelectorAll("[data-quiz-step]"));
      this.results = Array.from(this.querySelectorAll("[data-quiz-result]"));
      this.progress = this.querySelector("[data-quiz-progress]");
      this.progressText = this.querySelector("[data-quiz-progress-text]");
      this.header = this.querySelector("[data-quiz-header]");
      this.currentStep = 0;
      this.answers = [];

      this.addEventListener("click", (event) => this.handleClick(event), {
        signal: this.abortController.signal,
      });
      this.render();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    handleClick(event) {
      const option = event.target.closest("[data-quiz-option]");
      if (option) {
        this.choose(option);
        return;
      }
      if (event.target.closest("[data-quiz-back]")) this.back();
      if (event.target.closest("[data-quiz-restart]")) this.restart();
    }

    choose(option) {
      this.answers[this.currentStep] = {
        reduce: Number(option.dataset.reduce || 0),
        ha: Number(option.dataset.ha || 0),
      };

      if (option.dataset.result) {
        this.finish(option.dataset.result);
      } else if (this.currentStep < this.steps.length - 1) {
        this.currentStep += 1;
        this.render({ focus: true });
      } else {
        this.finish(this.score());
      }
    }

    score() {
      const totals = this.answers.reduce(
        (sum, answer) => ({
          reduce: sum.reduce + (answer?.reduce || 0),
          ha: sum.ha + (answer?.ha || 0),
        }),
        { reduce: 0, ha: 0 },
      );
      if (totals.reduce - totals.ha >= 3) return "reduce";
      if (totals.ha - totals.reduce >= 3) return "ha";
      return "both";
    }

    render({ focus = false } = {}) {
      if (this.header) this.header.hidden = false;
      this.results.forEach((result) => { result.hidden = true; });
      this.steps.forEach((step, index) => { step.hidden = index !== this.currentStep; });
      const current = this.currentStep + 1;
      const total = this.steps.length;
      this.progress.value = current;
      this.progress.max = total;
      this.progressText.textContent = this.dataset.progressTemplate
        .replace("{current}", current)
        .replace("{total}", total);
      if (focus) this.steps[this.currentStep]?.querySelector("[data-quiz-option]")?.focus();
    }

    back() {
      if (this.currentStep === 0) return;
      this.currentStep -= 1;
      this.answers.length = this.currentStep;
      this.render({ focus: true });
    }

    finish(key) {
      if (this.header) this.header.hidden = true;
      this.steps.forEach((step) => { step.hidden = true; });
      const result = this.results.find((item) => item.dataset.quizResult === key);
      if (!result) return;
      result.hidden = false;
      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: this.scrollBehavior(), block: "nearest" });
      window.dataLayer?.push({ event: "ca_quiz_complete", result: key });
    }

    restart() {
      this.currentStep = 0;
      this.answers = [];
      this.render({ focus: true });
      this.scrollIntoView({ behavior: this.scrollBehavior(), block: "start" });
    }

    scrollBehavior() {
      return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
    }
  }

  if (!customElements.get(ELEMENT_NAME)) customElements.define(ELEMENT_NAME, CaProtocolQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-split"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const playButton = event.target.closest('[data-science-video-play]');
    if (!playButton) return;

    const mediaPanel = playButton.closest('.science-split__panel--media');
    const video = mediaPanel?.querySelector('video');
    if (!video) return;

    try {
      video.controls = true;
      await video.play();
      mediaPanel.classList.add('is-playing');
    } catch {
      video.controls = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-process"] && !Shopify.designMode) return;
  try {
    
  function initializeTimelineProcess(sectionRoot = document) {
    sectionRoot.querySelectorAll('.timeline-process__scroll').forEach((timeline) => {
      if (timeline.dataset.timelineKeyboardReady === 'true') return
      timeline.dataset.timelineKeyboardReady = 'true'
      timeline.addEventListener('keydown', (event) => {
        if (event.target !== timeline) return
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
        event.preventDefault()
        const direction = event.key === 'ArrowRight' ? 1 : -1
        timeline.scrollBy({ left: timeline.clientWidth * 0.8 * direction, behavior: 'smooth' })
      })
    })
  }

  initializeTimelineProcess()
  document.addEventListener('shopify:section:load', (event) => initializeTimelineProcess(event.target))

  } catch(e) { console.error(e); }
})();
})();
